import { Component } from '@angular/core';

@Component({
    selector: 'ingot',
    templateUrl: 'ingot.component.html',
    styleUrls: ['ingot.component.scss'],
    standalone: false
})
export class IngotComponent {}
